const QUESTIONS = [
  {
    id: 'q1',
    text: 'Which city is the capital of England?',
    answers: ['London', 'Birmingham', 'Edinburgh', 'Manchester'],
  },
  {
    id: 'q2',
    text: 'Which city is the capital of Scotland?',
    answers: ['Edinburgh', 'Glasgow', 'Dundee', 'Aberdeen'],
  },
  {
    id: 'q3',
    text: 'Who is the shortest serving Prime Minister in UK history?',
    answers: ['Liz Truss', 'Rishi Sunak', 'Boris Johnson', 'Theresa May'],
  },

  {
    id: 'q4',
    text: 'How old was Queen Elizabeth II when she died?',
    answers: ['96', '93', '94', '95'],
  },
  {
    id: 'q5',
    text: 'Which is the second most populous city in the UK?',
    answers: ['Birmingham', 'Manchester', 'Leeds', 'Newcastle'],
  },
];

export default QUESTIONS;
